import type { ReactElement } from 'react';
import { useEffect } from 'react';
import styles from './QueueAlertToast.module.css';

export interface QueueAlertToastProps {
  /** Chamado 5s após a montagem (Design > Toast de Alerta: auto-dismiss,
   * "sem close button — auto-dismiss garante saída"). */
  onDismiss: () => void;
}

/** CA-08: alerta some sozinho após 5s — não há botão de fechar. */
const AUTO_DISMISS_MS = 5_000;

/**
 * Toast não-bloqueante exibido quando a `lead_queue` atinge 9.500 registros
 * (CA-08): alerta o operador sem impedir novas criações de leads.
 * Bottom-center, auto-dismiss em 5s (Design > Toast de Alerta).
 */
export function QueueAlertToast({ onDismiss }: QueueAlertToastProps): ReactElement {
  useEffect(() => {
    const timer = setTimeout(onDismiss, AUTO_DISMISS_MS);
    return () => clearTimeout(timer);
  }, [onDismiss]);

  return (
    <div
      className={styles.toast}
      role="alert"
      aria-live="assertive"
      aria-label="Memória da fila em alerta: 9.500 ou mais leads pendentes. Verifique a conexão."
    >
      <span className={styles.icon} aria-hidden="true">
        ⚠️
      </span>
      <p className={styles.message}>
        Memória da fila em alerta: 9.500+ leads pendentes. Verifique a conexão.
      </p>
    </div>
  );
}
